var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"campaign-offer-note"},[_c('span',{staticClass:"campaign-offer-note-tag"},[_vm._v("Black November:")]),_vm._v("\n  "+_vm._s(_vm.planName)+" com "+_vm._s(_vm.discount)+"% off "),_c('strong',[_vm._v("nos 2 primeiros meses")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e63f36e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscription/CampaignOfferNote.vue
// module id = null
// module chunks = 